import _classCallCheck from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
export var ContentBlockBase = /*#__PURE__*/function (_React$Component) {
  _inherits(ContentBlockBase, _React$Component);

  var _super = _createSuper(ContentBlockBase);

  function ContentBlockBase(props) {
    var _this;

    _classCallCheck(this, ContentBlockBase);

    _this = _super.call(this, props);

    _this.handleToggleCollapsed = function () {
      _this.setState({
        isCollapsed: !_this.state.isCollapsed
      });
    };

    _this.handleTabSelect = function (index) {
      _this.setState({
        selectedTabIndex: index,
        isCollapsed: false
      });
    };

    _this.state = {
      isCollapsed: props.disabled || props.isCollapsible && props.isCollapsed,
      selectedTabIndex: props.selectedTabIndex
    };
    return _this;
  }

  _createClass(ContentBlockBase, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.isCollapsed !== this.props.isCollapsed || nextProps.isCollapsible !== this.props.isCollapsible) {
        this.setState({
          isCollapsed: nextProps.isCollapsible && nextProps.isCollapsed
        });
      }

      if (nextProps.selectedTabIndex !== this.props.selectedTabIndex) {
        this.setState({
          selectedTabIndex: nextProps.selectedTabIndex,
          isCollapsed: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          dataTest = _this$props.dataTest;
      var _this$state = this.state,
          _this$state$isCollaps = _this$state.isCollapsed,
          isCollapsed = _this$state$isCollaps === void 0 ? false : _this$state$isCollaps,
          _this$state$selectedT = _this$state.selectedTabIndex,
          selectedTabIndex = _this$state$selectedT === void 0 ? 0 : _this$state$selectedT;
      var header = React.Children.toArray(children).find(function (child) {
        return child.type.displayName && child.type.displayName === 'ContentBlock.Header';
      });

      if (header) {
        header = React.cloneElement(header, {
          isCollapsible: this.props.isCollapsible,
          isCollapsed: isCollapsed,
          onExpandClick: this.handleToggleCollapsed,
          onTabSelect: this.handleTabSelect,
          selectedTabIndex: selectedTabIndex
        });
      }

      var contentBodies = React.Children.toArray(children).filter(function (child) {
        return child.type.displayName && child.type.displayName.indexOf('ContentBlock.Body') > -1;
      });
      return React.createElement("div", {
        "data-test": dataTest
      }, React.createElement("div", null, header), !isCollapsed && contentBodies.length > 0 && React.createElement("div", null, contentBodies[selectedTabIndex]));
    }
  }]);

  return ContentBlockBase;
}(React.Component);